<template>
  <div class="header navbar">
    <!-- logo -->
    <el-col :span="4" class="logo">
      <img src="../assets/image/logo.png" alt="" />
    </el-col>
    <!-- 导航区域 -->
    <el-col :span="16">
      <el-menu
        :default-active="$route.path"
        class="el-menu-demo"
        router
        mode="horizontal"
      >
        <template v-for="route in $router.options.routes">
          <el-menu-item
            v-if="!route.hasChild"
            :key="route.path"
            :index="route.path"
          >
            {{ route.name }}
          </el-menu-item>
        </template>
      </el-menu>
    </el-col>
  </div>
</template>

<script>
export default {
  name: "headers",
  data() {
    return {};
  },
  methods: {
    eventTest(bShow) {
      // 发送监听事件
      console.log("emit event_bus msg");
      this.emit.emit("event_bus", bShow);
    },
  },
};
</script>

<style scoped>
.navbar {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  border: none;
  background-color: #fff;
  z-index: 10000;
  -webkit-transition: background-color 0.5s linear;
  -o-transition: background-color 0.5s linear;
  transition: background-color 0.5s linear;
  height: 50px;
  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.header {
  position: relative;
  top: 0;
  height: 60px;
  z-index: 999;
}

.logo img {
  position: relative;
  width: 60px;
  height: 60px;
}
</style>
